/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.42"
        height="15.7"
        viewBox="0 0 19.42 15.7"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M5.1 12.62a6.57 6.57 0 0 0 6.83 1.62 6.67 6.67 0 0 0 4.42-5.52l-1.57 1.11-.64-.92 3.11-2.19 2.17 3.13-.91.65-1.05-1.52A7.73 7.73 0 0 1 2.8 11.26l1-.48a7 7 0 0 0 1.3 1.84Zm-3-5.88a7.73 7.73 0 0 1 14.69-2.26l-1 .49a6.59 6.59 0 0 0-12.53 2L5 5.74l.64.92-3.32 2.35L0 5.66l.91-.65Zm7 5.45.12-1a3.6 3.6 0 0 1-1.34-.41v-.86a4.2 4.2 0 0 0 1.45.4l.27-2.17-.19-.07a1.73 1.73 0 0 1-1.5-1.84c0-1.08.7-1.86 2.11-1.86l.07-.57h.66l-.08.62a3.25 3.25 0 0 1 1 .31v.87a3.91 3.91 0 0 0-1.07-.3l-.25 2c1.13.32 1.69.75 1.69 1.93s-.69 2-2.17 2l-.12 1ZM11 9.3c0-.51-.17-.77-.77-1l-.24 2c.73-.08 1.04-.47 1.04-1ZM8.92 6.1c0 .51.15.75.81 1l.22-1.85c-.63-.01-1 .32-1 .85Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'DollarSignWithRevolvingArrowsIcon';

export default Icon;
